module.exports = __webpack_public_path__ + "img/bj@2x.42da00be.png";